import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddDeviceActions from './add-device.actions';

export const addDeviceFeatureKey = 'addDevice';

export interface AddDeviceState {
   callState: CallState;
   deviceType: string | null;
   accountId: number | null;
   accountName: string | null;
}

export const initialState: AddDeviceState = {
   callState: LoadingState.Init,
   deviceType: null,
   accountId: null,
   accountName: null,
};

const addDeviceReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddDeviceActions.createDevice, AddDeviceActions.createDeviceAndAddAnother, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(
      AddDeviceActions.createDeviceSuccess,
      AddDeviceActions.createDeviceFailure,
      AddDeviceActions.createDeviceAndAddAnotherSuccess,
      AddDeviceActions.createDeviceAndAddAnotherFailure,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   ),
   on(AddDeviceActions.setDeviceTypeOnForm, (state, { deviceType }) => ({
      ...state,
      deviceType,
   })),
   on(AddDeviceActions.createDeviceAndAddAnotherSuccess, (state, { accountId, accountName }) => ({
      ...state,
      accountId,
      accountName,
   }))
);

export function reducer(state: AddDeviceState | undefined, action: Action) {
   return addDeviceReducer(state, action);
}
